// extracted by mini-css-extract-plugin
module.exports = {"solz19o":"solz19o","w1eao72h":"w1eao72h","b1mbufpb":"b1mbufpb"};